import { render } from "./TheFontStyle.vue?vue&type=template&id=fc58ff42&ts=true"
import script from "./TheFontStyle.vue?vue&type=script&lang=ts"
export * from "./TheFontStyle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__